// @ts-nocheck
import Styleguide from "@toolkit/Framework/Types/Styleguide";

const footer: Styleguide["footer"] = {
    isFullWidth: true,
    fullWidthStylingType: null as any,
    fullWidthColor: null as any,
    fullWidthImage: null as any,
    fullWidthImageFocalPoint: null as any,
};

export default footer;
